import productPage from './pages/product-page';

const pageSelector = document.getElementById('page-selector');

if (pageSelector) {
    const pageName = pageSelector.getAttribute('data-page-name');

    if (pageName === 'product-page') {
        window.addEventListener('load', () => {
            productPage();
        })
    }
}
